import { render, staticRenderFns } from "./application-feature-discovery-container.vue?vue&type=template&id=72ed8b78"
import script from "./application-feature-discovery-container.vue?vue&type=script&lang=js"
export * from "./application-feature-discovery-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports